export class Subject {
    name:string=""
    server_syllabus_id=0
    server_level_id=0
	  description=""
    formData(countryName:string){
      let body = new URLSearchParams();
      body.set('name', this.name);
      body.set('server_syllabus_id', this.server_syllabus_id.toString());
      body.set('server_level_id', this.server_level_id.toString());
      body.set('description', this.name+" "+countryName);

      return body.toString()
    }
}
